export default __webpack_public_path__ + "static/media/wallet-icon.0fd5e806.svg";